
/**
 * @category BCF
 */
export class ViewSetupHints {
    /**
     * Visibility of spaces
     */
    public spaces_visible: boolean;

    /**
     * Visibility of space boundaries
     */
    public space_boundaries_visible: boolean;

    /**
     * Visibility of openings
     */
    public openings_visible: boolean;
}